module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/instant-cbbf0fa4c7df19f5112172b3785e1d07.svg&quot;;"